import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/blog/shopify-plus-partner")({
  beforeLoad: () => {
    throw redirect({
      href: "/blog/shopify-plus-technical-debt",
      statusCode: 301,
    });
  },
});
